import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { EntInfosContainer, FormSelect } from '../Infos/Infos.styled'
import { EIFormCol, EIFormContainer } from '../../../containers/Entity/Entity.styled';
import { FormGroup, FormInput, FormLabel } from '../../../styles/Common';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal'
import CancelIcon from '@mui/icons-material/Cancel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TH, THead, TBody, Table, TD } from '../../../styles/Table.styled';
import {  faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { getArbreJson, getNotyfObject, getProfilsByEtape } from '../../../shared/utility'; 
import TextField from '@mui/material/TextField';
import { format } from 'date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { fr } from 'date-fns/locale';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DPContainer } from '../../../containers/CampaignForm/CampaignForm.styled';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
function InfoStepsCamapgneEnquete({ steps, setSteps, userType, cannotBeModified }) {
    const { t } = useTranslation();
    const [showModalConfirmation, setShowModalConfirmation] = useState(false)
    const [indexLevelTodDelete,setIndexLevelToDelete]=useState()
    const notyf = getNotyfObject();
    const [endDateError, setEndDateError] = useState(false);
    const [startDateError, setStartDateError] = useState(false);
    const [open, setOpen] = useState(false);
    const canalOptions = [
        { value: '1', label: 'Email' },
        { value: '2', label: 'Papier' },
        { value: '3', label: 'SMS' }
    ];
   
    const handleDatePrevisionnelleChange = (date,index) => {
        if (date.toString() === "Invalid Date") {
            setStartDateError(true)
        } else
            if (date.getFullYear <= 1900 || date.getFullYear > 2100) {
                setStartDateError(true)
            } else {
                setStartDateError(false)
            }
            const key = "datePrevisionnelle";
            setSteps((prevState) => {
                let newSteps = [...prevState]
                newSteps[index] = { ...newSteps[index], [key]: format(new Date(new Date(date.getTime())), 'yyyy-MM-dd') }
                return newSteps
            })
    };
    
    const handleDateStopSaisieChange = (date,index) => {
        if (date.toString() === "Invalid Date") {
            setEndDateError(true)
        } else
            if (date.getFullYear <= 1900 || date.getFullYear > 2100) {
                setEndDateError(true)
            } else {
                setEndDateError(false)
            }

        const key = "dateStopSaisie";
        setSteps((prevState) => {
            let newSteps = [...prevState]
            newSteps[index] = { ...newSteps[index], [key]: format(new Date(new Date(date.getTime())), 'yyyy-MM-dd') }
            return newSteps
        })
    
    };
    function hasEmptyProperty(obj) {
       
        for (let key in obj) {
          if (obj.hasOwnProperty(key) && key != "children" && key != "typeEnquete" && key !='typeSelectionDossier') {
                if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                    return true; // Retourne true si une propriété est vide ou null
                }  
            }
        }
        return false; // Retourne false si aucune propriété vide ou null n'est trouvée
    }

    const addNewStep = () => {
        if (!cannotBeModified) {
          let p = { id: crypto.randomUUID(), typeEtape: null, libelle: "", datePrevisionnelle: '', typeSelectionDossier: 0, dateStopSaisie: '', typeProfil: "", actif: true, children: [] };
            let stepsTemp = [...steps];
            let hasEmptyElement = stepsTemp.some((item) => hasEmptyProperty(item))
            if (hasEmptyElement) {
                notyf.error("Vous ne pouvez pas ajouter un nouveau élément, Var il exsite un élément qui contient un champ vide ou null");
            } else {
                stepsTemp.push(p);
                setSteps(stepsTemp);
            }
        }
    }

    const inputChangeHandlerLevel = (e, index) => {
        if (!cannotBeModified) {
            const key = e?.target.name;
            let value = null;
            if (key == "libelle") {
                value = e.target.value;
            } else {
                value = parseInt(e.target.value, 10);
            }

            setSteps((prevState) => {
                let newSteps = [...prevState]
                newSteps[index] = { ...newSteps[index], [key]: value }
                return newSteps
            })
        }   
       
    } 

    const generateMinEndDate = (index) => {
        if (index === 0) {
            return null;
        } else {
            const previousItem = steps[index - 1];
            return previousItem?.dateFin ? new Date(previousItem.dateFin) : null;
        }
    };

    const confirmeDeleteLevel = (index) => {
        if (!cannotBeModified) {
            let tempSteps = [...steps]
            tempSteps.splice(index, 1)
            setSteps(tempSteps)
        }                 
    }

    const body = useMemo(() => steps?.map((step, index) => (
        <TBody key={index}>
            <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }} >
                <TD style={{ width: "8%", paddingTop: "5px" }}>
                    <FormGroup bd={"#000"} style={{ paddingTop: "15px" }}>
                        <FormSelect
                            style={{ textAlign: "start" }}
                            disabled={!step.actif}
                            name="typeEnquete"
                            value={step?.typeEnquete || ""}
                            onChange={(e) => inputChangeHandlerLevel(e, index)}
                        >
                            <option >SLS/OPS</option>
                           
                            <option value="1">SLS</option>
                            <option value="2">OPS</option>
                        </FormSelect>
                    </FormGroup>
                 </TD>

                 
                <TD style={{ width: "14%", paddingTop: "5px" }}>
                    <FormGroup bd={"#000"} style={{ paddingTop: "15px" }}>
                        <FormInput style={{ textAlign: "start"}}
                            id="Libelle"
                            type="texte"
                            name="libelle"
                            disabled={!step.actif}
                            placeHolder="Envoi initial mars"
                            value={step?.libelle || ""}
                            onChange={(e) => inputChangeHandlerLevel(e, index)}
                            maxLength={255}

                        />
                    </FormGroup>
                </TD>

                <TD style={{ width: "16%", paddingTop: "5px" }}>
                    <FormGroup bd={"#000"} style={{ paddingTop:"15px" }}>                     
                        <FormSelect    
                            style={{ textAlign: "start" }}
                            id="countryCode"
                            name="typeEtape"
                            value={step?.typeEtape || ""}
                            disabled={!step.actif}
                            onChange={(e) => inputChangeHandlerLevel(e, index)}
                        >
                            <option ></option>
                            <option value="1">Envoi initial</option>
                            <option value="2">Relance</option>
                            <option value="3">Mise en demeure</option>
                        </FormSelect>
                    </FormGroup>
                </TD>
          <TD style={{ width: "8%", paddingTop: "5px" }}>
            <FormGroup bd={"#000"} style={{ paddingTop: "15px" }}>
              <FormSelect
                style={{ textAlign: "start" }}
                disabled={step.typeEtape == '1'}
                name="typeSelectionDossier"
                value={step?.typeSelectionDossier ?? 0}
                onChange={(e) => inputChangeHandlerLevel(e, index)}
              >
                <option value="0">Global</option>
                <option value="1">Non répondu</option>
                <option value="2">Incomplet</option>
                <option value="3">Non rép./Incomplet</option>

              </FormSelect>
            </FormGroup>
          </TD>
                <TD style={{ width: "16%", paddingTop: "7px" }}>
                    <FormGroup bd={"#fff"}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                            <DPContainer>
                                <DatePicker
                                    id="date-picker-dialog"
                                    label="Date de fin de saisie"
                                    format="dd/MM/yyyy"
                                    value={new Date(step?.dateStopSaisie)}
                                    readOnly={cannotBeModified}
                                    onChange={(e) => handleDateStopSaisieChange(e, index)}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    disabled={!step.actif}
                                    //minDate={selectedStartDate}
                                    //minDate={generateMinEndDate(index)}
                                    invalidDateMessage="Format de date invalide"
                                    maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                    minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </DPContainer>
                        </LocalizationProvider>
                    </FormGroup>
                </TD>

                <TD style={{ width: "16%", paddingTop: "7px" }}>
                    <FormGroup bd={"#fff" } >
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                            <DPContainer>
                                <DatePicker
                                    id="date-picker-dialog"
                                    label="Date d'envoi" 
                                    format="dd/MM/yyyy"
                                    readOnly={cannotBeModified }
                                    disabled={!step.actif || (step.dateStopSaisie == "")}
                                    value={new Date(step?.datePrevisionnelle)}
                                    onChange={(e) => handleDatePrevisionnelleChange(e, index)}
                                   // onChange={handleOuvertureOpsDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    minDate={new Date(step.dateStopSaisie)}
                                    invalidDateMessage="Format de date invalide"
                                    maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                    minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                    renderInput={(params) => <TextField {...params} />}
                                // open={true} control open dialog state
                                />
                            </DPContainer>
                         
                        </LocalizationProvider>
                    </FormGroup>
                </TD>

                {/*<TD style={{ width: "24%" }}>*/}
                {/*    <CanalDragSelect setSteps={setSteps} step={step} indexStep={index} steps={steps} cannotBeModified={cannotBeModified} />*/}
                {/*</TD>*/}

                <TD style={{ width: "16%", paddingTop: "5px" }}>
                    <FormGroup bd={"#000"} style={{ paddingTop: "15px" }}>  
                        <FormSelect
                            style={{ textAlign: "start" }}
                            id="countryCode"
                            name="typeProfil"
                            disabled={!step.actif}
                            value={step?.typeProfil || ""}
                            onChange={(e) => inputChangeHandlerLevel(e, index)}
                        >
                            <option >Choisir un profile</option>
                            {getProfilsByEtape(step.typeEtape).map((item, index) => (
                                <option key={index} value={item?.value}>
                                    {item?.label}
                                </option>
                            ))}
                        </FormSelect>
                    </FormGroup>
                </TD>

                <TD style={{ width: "4%" }}>
                    {!cannotBeModified && step.actif&& <CancelIcon onClick={(e) => confirmeDeleteLevel(index)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />}
                </TD>
            </tr>
            <tr style={{ width: "95%", padding: "5px", display: "flex", justifyContent: "space-between", borderTop:"2px solid #e9ecef" }} >
            </tr>
        </TBody>
    )), [steps])
   
    return (
        <>
            <EntInfosContainer>                
              <Accordion expanded={open} onChange={() => setOpen(!open)} >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ fontSize: "xx-large" }} />}
                >
                  <Typography>
                    Étapes de la campagne
                  </Typography>

                  <FontAwesomeIcon
                    icon={faCirclePlus}
                    style={{
                      marginLeft: "15px",
                      color: "#2174b980",
                      fontSize: "1.25rem",
                      cursor: "pointer"
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // important pour éviter toggle accordion
                      addNewStep();
                    }}
                  />

                </AccordionSummary>

                    <AccordionDetails>
                      <Table style={{ marginTop: "10px" }}>
                        <THead>
                            <tr style={{ width: "100%", display: "flex", justifyContent: "space-between", paddingTop: "5px" }}>
                            <TH style={{ width: "8%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Enquêtes</TH>
                        
                            <TH style={{ width: "14%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Libelle</TH>                                       
                            <TH style={{ width: "16%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Etape </TH>
                            <TH style={{ width: "8%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Type selection</TH>
                            <TH style={{ width: "16%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Date de fin de saisie </TH>
                            <TH style={{ width: "16%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Date d'envoi </TH>                                       
                            <TH style={{ width: "16%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Profile Communication </TH>
                            <TH style={{ width: "4%" }} ></TH>
                            </tr>
                        </THead>
                        {body}
                      </Table>
                
                    </AccordionDetails>
              </Accordion>
                {
                    <ConfirmationModal
                        show={showModalConfirmation}
                        modalClosed={() => setShowModalConfirmation(false) }
                        title={"Confirmation de suppression"}
                        message={`Êtes-vous sûr de vouloir supprimer cette ligne ?`}
                        confirm={()=>confirmeDeleteLevel(indexLevelTodDelete)}
                        cancel={() => setShowModalConfirmation(false)}
                    />
                }
            </EntInfosContainer>
        </>
    );
}

export default InfoStepsCamapgneEnquete;


